module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/google-play-store-es-a517cb5eecaa00032b18e030d3daf58c.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/google-play-store-es.svg
// module id = /2aD
// module chunks = 21 23